<template>
    <div class="post-wrap page-inner">
        <Title v-if="page">
            <h2>Who we are</h2>
        </Title>

        <Content v-if="page">
            <div class="box" v-html="page.content.rendered"></div>
        </Content>

        <div
            class="job-list"
            v-if="page.open_roles && page.open_roles.length !== 0"
        >
            <h2 class="title">Open roles</h2>
            <ul>
                <li v-for="(item, index) in page.open_roles" :key="index">
                    <router-link
                        :to="'/job/' + item.post_name"
                        :id="`${item.post_name}-page`"
                    >
                        <p v-html="item.post_title"></p>
                        <p v-if="item.subheading" v-html="item.subheading"></p>
                    </router-link>
                </li>
            </ul>
        </div>

        <Content v-if="page">
            <div class="box" v-html="page.bottom_text"></div>
        </Content>

        <Loading v-if="!page" class="static" />
        <RelatedItems
            v-if="page && page.related_items && page.related_items.length !== 0"
            :list="page.related_items"
        />
    </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import Loading from "@/components/Loading.vue";
import Content from "@/components/ui/Content.vue";
import RelatedItems from "@/components/RelatedItems.vue";

export default {
    name: "jobs",

    data() {
        return {
            page: false,
            id: ""
        };
    },

    components: {
        Title,
        Loading,
        Content,
        RelatedItems
    },

    watch: {
        "$route.params": {
            handler(params) {
                this.fetchData(params);
            },
            immediate: true
        }
    },

    methods: {
        fetchData(params) {
            // console.log(params)

            this.page = false;
            this.$ajax.get("pages?slug=join-us").then(res => {
                // if (!res.data[0].sections) res.data[0].sections = [];
                document.title =
                    window.globals.site_title +
                    " — " +
                    this.$decode(res.data[0].title.rendered);

                // if (res.data[0].sub_pages) this.sub_pages = res.data[0].sub_pages;
                if (res.data[0].parent_page_name)
                    document.body.classList.add(
                        "parent-page-" + res.data[0].parent_page_name
                    );
                document.body.classList.add("page-" + res.data[0].slug);
                this.page = res.data[0];
            });
        }
    }
};
</script>

<style lang="scss">
.job-list {
    margin: var(--padding-x2) var(--padding);
    padding: var(--padding) 0 1rem calc(var(--margin) - var(--padding));
    border-top: var(--border) solid;
    border-bottom: var(--border) solid;

    .title {
        padding: 0 0 var(--padding);
        font-size: var(--large-size);
    }

    ul {
        display: flex;
        flex-wrap: wrap;

        li {
            width: 50%;
            padding: 0 0 1em;
            a {
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}

hr {
    border-bottom: var(--border) solid;
    margin: var(--padding) calc((var(--margin) - var(--padding)) * (-1))
        var(--padding) calc((var(--margin) - var(--padding)) * (-1));
}

@media only screen and (max-width: 767px) {
    .page-inner .ui-enter h2:first-child {
        font-size: var(--title-size);
        margin-top: 0;
    }

    .job-list {
        margin: var(--padding-x2) 0;
    }
}
</style>
